import PlacesAutocomplete from './PlacesAutocomplete';

export default PlacesAutocomplete;



// WEBPACK FOOTER //
// ./src/common/components/PlacesAutocomplete/index.js